import React, { useMemo, useState } from 'react';
import { Button } from '@naf-simba/elements-buttons';
import { Message } from '@naf/input';
import { useForm } from 'react-hook-form';
import { apiClient, ApiType } from '@shared/apiClient';
import { Spinner } from '@components/spinner/Spinner';
import { Form } from '@components/Form';
import { CtaActivateButtonProps } from './BenefitCallToActions.types';
import * as S from './BenefitCallToActions.styles';

const CtaActivateButton = ({ callToAction }: CtaActivateButtonProps) => {
  const [InternalEndpointActivateState, setInternalEndpointActivateState] = useState<
    'initial' | 'loading' | 'success' | 'error'
  >('initial');

  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({ mode: 'onChange' });

  const callToActionFields = useMemo(
    () =>
      callToAction?.fieldComponents?.map((field) => {
        if (InternalEndpointActivateState === 'success') {
          return { ...field, isReadOnly: true };
        }
        return field;
      }),
    [callToAction.fieldComponents, InternalEndpointActivateState],
  );

  const handleCtaBlankExternalTracking = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    try {
      setInternalEndpointActivateState('loading');
      const data = getValues();
      const response = await apiClient.post(ApiType.external, {
        url: callToAction.internalEndpoint as string,
        data: { fields: Object.entries(data).map(([key, value]) => ({ id: key, value })) },
        skipNafHeaders: false, // Keep NAF headers for internal endpoints
      });
      if (response.status === 200) {
        setInternalEndpointActivateState('success');
      } else {
        setInternalEndpointActivateState('error');
      }
    } catch (error) {
      setInternalEndpointActivateState('error');
    }
  };

  return (
    <S.CtaActivateButtonWrapper>
      {callToAction.fieldComponents?.length > 0 ? (
        <Form fieldComponents={callToActionFields} control={control} handleSubmit={handleSubmit} errors={errors} />
      ) : null}
      <Button
        onClick={handleCtaBlankExternalTracking}
        disabled={callToAction.disabled || InternalEndpointActivateState === 'success'}
        type="button"
      >
        {
          {
            initial: callToAction.buttonText,
            loading: <Spinner />,
            success: 'Aktivert',
            error: <Message error>Noe gikk galt</Message>,
          }[InternalEndpointActivateState]
        }
      </Button>
    </S.CtaActivateButtonWrapper>
  );
};

export default CtaActivateButton;
